import { useContext, useRef, useEffect, useMemo, useState } from 'react';
import { AppContext } from 'Context';
import useSWR from 'swr';
import Paper from '@mui/material/Paper';
import { axios, dataFetcher, endpoints, baseUrl } from 'Api';
import Table from '@mui/material/Table';
import { ref, get, getDatabase, off, onValue, update } from 'firebase/database';
import { toast } from 'react-toastify';
import Spinner from 'Components/Spinner';
import ListItemText from '@mui/material/ListItemText';
import { v4 as uuid } from 'uuid';
import AWS from 'aws-sdk';
import { addS3VideoDraftContent, addVideoDraftContent } from 'Api/apiFunctions';
import { saveUploadInfo, saveUploadDetails, saveTitle, saveDummy, removeDummy, removeTitle } from 'store/store';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { useSelector, useDispatch } from 'react-redux';
import noImageAvailable from 'Assets/noimage-available.png';
import Switch from '@mui/material/Switch';
import generatingThumbnail from 'Assets/generating-thumbnail.jpg';
import noPhotoAvailable from 'Assets/no-image-available.png';
import CloudUpl from 'Assets/cloud-upload.png';
import OutlinedInput from '@mui/material/OutlinedInput';
import TableHead from '@mui/material/TableHead';
import { useNavigate, useLocation } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import { ReactComponent as CloseIcon } from 'Assets/close.svg';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TableRow from '@mui/material/TableRow';
import { Checkbox as MuiCheckbox, withStyles, Typography } from '@material-ui/core';
import { Check as CheckIcon, Close } from '@material-ui/icons'; // Import the CheckIcon
import getMyContentsBasedOnUploadDate from '../Api/getMyContentsBasedOnUploadDate';
import { Radio } from './upload-modal/components/Material-reDesign';
import { Checkbox, StyledCheckbox } from '../Pages/private/videos/components/CustomDesigns';
import { GroupSelector } from './group-selector/index';
import { awsConfig, generateS3Url, getBucketName, getBucketNamePath } from '../Api/awsConfig';
import styles from './Listing.module.css';
import { Pathname } from '../Routes';
import DeleteIcon from '../Assets/delete.png';
import SpinnerImage from '../Assets/Spinner-3.gif';

export default function ListingModal({ buttonText, setButtonText, open, key, videoFiles, setVideoFiles, setOpen, setEditLoader }) {
  // const navigate = useNavigate();
  const { setAppSnackbar, s3Data, firebaseDatabase, setVideoUploadedParts, langText, userDetails,
    setUploadContainer, setIamUploading, setdisableDrag, setdidIOpenModal, subscriptionDetails,
    autoSignIn, setSelectedFiles, uploadQueue, setUploadQueue, activeUploads, setActiveUploads, draftOfUpload, setDraftOfUpload, MAX_VIDEOS, uploadProcessing,
    setUploadProcessing, setNavigateOnceClicked, setUploadContainer2, setAllvideoData } = useContext(AppContext);
  const spinerSmall = 'spinex';
  const uploadPercentages = useSelector((state) => state.upload);
  const handleClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };
  const defaultVideoDetails = {
    name: undefined,
    duration: undefined,
    size: undefined,
  };
  const test = useSelector((state) => state.titleBulk);
const dispatch = useDispatch();
const updateTitle = (draft_id, data, status = 1) => {
  if (status === 1) {
    dispatch(saveTitle({ [draft_id]: data }));
  } else {
    dispatch(removeTitle(draft_id));
  }
};
  const getToken = () => localStorage.getItem('token');
  const videoRef = useRef(null);
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const userId = userDetails?.isSubscription?.user_id;
  const [t, setT] = useState(false);
  const [videoDetails, setVideoDetails] = useState(defaultVideoDetails);
  const [videoGroup, setVideoGroup] = useState([]);
  const [videoVisibility, setVideoVisibility] = useState(null);
  const [options, setOptions] = useState([]);
  const [videoThumbnails, setVideoThumbnails] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const [thumbnailGenerationStatus, setThumbnailGenerationStatus] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isItDelete, setisItDelete] = useState(true);
  const [title, setTitle] = useState('');
  const [addEditCategory, setAddEditCategory] = useState(false);
const [addingNewCategory, setAddingNewCategory] = useState({});
  // const [buttonText, setButtonText] = useState('Save to Draft');
  const [videoThumbnails64, setVideoThumbnails64] = useState([]);
  const [droper, setDroper] = useState(false);
  const handleCancel = (e, i) => {
    setTitle('');
    // setAddingNewCategory((prevState) => ({
    //   ...prevState,
    //   [i]: false, // Set the specific index to false
    // }));
  };
  const [updateTrigger, setUpdateTrigger] = useState(false);
  function formatFileSizeAccMb(sizeInBytes) {
    const megabyte = 1024 * 1024;
    const sizeInMB = sizeInBytes / megabyte;
    return sizeInMB.toFixed(2);
  }
  const [selectedItems, setSelectedItems] = useState(Array(videoFiles?.length).fill({
    token: getToken(),
    group_ids: [],
    draftId: '',
    thumbnails: '',
    name: '',
    description: '',
    category: '',
    categoryName: '',
    playlist: [],
    visibility: '2',
    size: '',
  }));

  useEffect(() => {
    // eslint-disable-next-line
    videoFiles.forEach((file) => {
      // eslint-disable-next-line
      file.draftId = uuid();
    });
  }, [updateTrigger]);
  useEffect(() => {
    const statuses = Object.values(thumbnailGenerationStatus);
    const anyGenerating = statuses.some((status) => status === 'generating');
    if (anyGenerating && isItDelete) {
      setIsLoading(true);
    } else {
      const allSuccessOrFailed = statuses.every((status) => status === 'success' || status === 'failed');
      if (allSuccessOrFailed) {
        setIsLoading(false);
      }
    }
  }, [thumbnailGenerationStatus]);
  useEffect(() => {
    const allItems = videoFiles.map((obj, i) => ({
      token: getToken(),
      group_ids: selectedItems[i]?.group_ids,
      draftId: obj?.draftId,
      thumbnails: videoThumbnails[i],
      name: obj.name,
      description: selectedItems[i]?.description,
      category: selectedItems[i]?.category,
categoryName: selectedItems[i]?.categoryName,
      playlist: selectedItems[i]?.playlist,
      visibility: selectedItems[i]?.visibility,
      size: formatFileSizeAccMb(obj.size)
    }));
    setSelectedItems(allItems);
  }, [videoFiles]);

  const selectGroup = (id, index) => {
    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index].group_ids = videoGroup[index]?.includes(id)
        ? videoGroup[index].filter((groupId) => groupId !== id)
        : [...(videoGroup[index] || []), id];
      return updatedItems;
    });
    // Update videoGroup to keep track of groups for each item individually
    setVideoGroup((prevVideoGroup) => {
      const updatedVideoGroup = [...prevVideoGroup];
      updatedVideoGroup[index] = updatedVideoGroup[index]?.includes(id)
        ? updatedVideoGroup[index].filter((groupId) => groupId !== id)
        : [...(updatedVideoGroup[index] || []), id];
      return updatedVideoGroup;
    });
  };
  const iteratorNum = [];
  const totalNum = [];
  let tempPercentages;
  const formDataJsonString = [];
  AWS.config.update({
    region: awsConfig.region,
    accessKeyId: awsConfig.accessKey,
    secretAccessKey: awsConfig.secretKey,
  });
  AWS.config.httpOptions.timeout = 0;
  const s3 = new AWS.S3();
  const { isValidating: gettingPlaylists, mutate: getPlaylists } = useSWR(endpoints.getMyPlaylist, {
    onSuccess: ({ success, data }) => {
      if (success) {
        setOptions(data?.map(({ id, title }) => ({ name: title, value: id })));
      } else {
        setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong while fetching you playlists' });
      }
    },
    onError: () => {
      setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong while fetching you playlists' });
    },
  });
  const [categrory, setCategrory] = useState(undefined);
  const fetchCategories = async () => {
    try {
      const token = getToken(); // Get the token
      const response = await axios.post(
        `${baseUrl}/${endpoints.getMyCategories}`,
        {}, // Empty body for the POST request
        {
          headers: {
            Authorization: `Bearer ${token}`, // Token in Authorization header
          },
        }
      );
      // Check if the response is successful
      if (response?.data?.success) {
        setCategrory(response?.data?.data?.map(({ title: name, id: value }) => ({ name, value })));
        // eslint-disable-next-line
      } else {
        console.error('Failed to fetch categories:', response.data.message);
        return [];
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  };
  useEffect(() => {
    setEditLoader(false);
    getPlaylists();
    fetchCategories();
    setdisableDrag(false);
    setButtonText('Save to Draft');
    setIsLoading(false);
    setisItDelete(true);
    setThumbnailGenerationStatus({});
    // setdidIOpenModal(true);
    return () => {
      // setdisableDrag(true);
      setdidIOpenModal(false);
    };
  }, []);

  const updateUploadDetails = (draft_id, data) => {
    dispatch(saveUploadDetails({ [draft_id]: data }));
  };

const updateItem = (percentage, draft_id, filename, uploadPercentages, updateUploadPercentages) => {
  const percent = parseInt((percentage / totalNum[draft_id]) * 100, 10);
  const trimmedFilename = filename.length > 26 ? `${filename.substring(0, 26)}...` : filename;
    const newPercentages = { ...uploadPercentages, [draft_id]: percent };
    tempPercentages = newPercentages;
    updateUploadPercentages(draft_id, percent);
    toast.update(draft_id, { render: `${trimmedFilename} ${percent}%`, autoClose: false });
};
const closeToast = (draft_id, message, type) => {
  toast.update(draft_id, { closeButton: false, render: message, type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, autoClose: 3000 });
  setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
};
async function uploadPart(bucket, key, partNumber, partBody, uploadId, setVideoUploadedParts, filename, draft_id, uploadPercentages, updateUploadPercentages, partSize, startTime, fileSize) {
  const params = {
    Bucket: bucket,
    Key: key,
    PartNumber: partNumber,
    UploadId: uploadId,
    Body: partBody,
  };
  return s3.uploadPart(params)
    .promise()
    .then((data) => {
      const currentTime = new Date().getTime();
      const elapsedSize = (partNumber * partSize) / 1024 / 1024;
      const elapsedTime = (currentTime - startTime) / 1000;
      const remainingSize = (fileSize / 1024 / 1024) - elapsedSize;
      updateUploadDetails(draft_id, { elapsed_size: elapsedSize, elapsed_time: elapsedTime, remaining_size: remainingSize > 0 ? remainingSize : 0 });
      iteratorNum[draft_id] += 1;
      updateItem(iteratorNum[draft_id], draft_id, filename, uploadPercentages, updateUploadPercentages);
      setVideoUploadedParts((prevState = []) => [...prevState, partNumber]);
      return data;
    })
    .catch((error) => {
      console.error(`AWS Multipart Upload : Error uploading part ${partNumber}:`, error);
      throw error; // Rethrow the error to be handled by the caller
    });
}

const queue = []; // A queue to hold the tasks
let isProcessing = false; // A flag to indicate whether the queue is being processed

async function processQueue() {
  if (isProcessing) return; // Prevent duplicate processing
  isProcessing = true;

  while (queue.length > 0) {
    const task = queue.shift(); // Take the first task
    // eslint-disable-next-line
    if (task) await task(); // Execute the task
  }

  isProcessing = false; // Reset the flag once done
}

function enqueueTask(task) {
  queue.push(task); // Add a new task to the queue
  processQueue(); // Trigger queue processing
}
const fetchContents = async () => {
  try {
      const userId = userDetails?.myId;
      const token = getToken();
      const data = await getMyContentsBasedOnUploadDate(userId, 1, '', 'date', 0);
      setAllvideoData(data?.data);
  } catch (error) {
      console.error('Failed to fetch contents:', error);
  }
};
async function sendVideoDataToServer(theGreatPayload, draft_id) {
  const apiUrl = `${baseUrl}/V6/addVideo`;
  try {
    const response = await axios.post(apiUrl, theGreatPayload);
    fetchContents();
    closeToast(draft_id, 'Uploading completed', 'success');
    autoSignIn();
    setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => id !== draft_id));
  } catch (error) {
    console.error('Error sending video data:', error);
  }
}
// function sendVideoDataToServer(theGreatPayload, draft_id) {
//   enqueueTask(async () => {
//     const apiUrl = `${baseUrl}/V6/addVideo`;
//     try {
//       await axios.post(apiUrl, theGreatPayload);
//       fetchContents();
//       autoSignIn();
//       closeToast(draft_id, 'Uploading completed', 'success');
//       setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => id !== draft_id));
//     } catch (error) {
//       console.error(`Error in sendVideoDataToServer for draft_id: ${draft_id}`, error);
//     }
//   });
// }
async function completeMultipartUpload(bucket, key, parts, uploadId, file, index) {
  const params = {
    Bucket: bucket,
    Key: key,
    MultipartUpload: {
      Parts: parts,
    },
    UploadId: uploadId,
  };
  try {
    const response = await s3.completeMultipartUpload(params).promise();
    let videoDuration = 0;
    let videoHeightI = 0;
    let videoWidthI = 0;
    try {
      const videoElement = document.createElement('video');
      videoElement.src = URL.createObjectURL(file);
      await videoElement?.load();
      videoElement.muted = true;
  // Wait for the metadata to load to access duration, height, and width
  await new Promise((resolve, reject) => {
    videoElement.addEventListener('loadedmetadata', () => {
      videoDuration = videoElement.duration;
      videoHeightI = videoElement.videoHeight;
      videoWidthI = videoElement.videoWidth;
      resolve();
    });
    videoElement.addEventListener('error', reject);
  });
  try {
    await videoElement.play();
  } catch (playError) {
    console.warn('Video play was prevented:', playError);
  }
      videoElement?.pause();
    } catch (e) {
      console.error('Error in getting width and height:', e);
    }
    const formData = new FormData();
    const s3Url = generateS3Url();
    formData.append('token', getToken());
    formData.append('draft_id', file?.draftId);
    videoThumbnails[index] && formData.append('thumbnail', videoThumbnails[index][0] ?? videoThumbnails[index]);
    if (videoThumbnails[index] && Array.isArray(videoThumbnails[index])) {
      videoThumbnails[index].forEach((thumbnail) => {
        formData.append('thumbnails[]', thumbnail);
      });
    }
    formData.append('title', test[file?.draftId]);
    formData.append('video_duration', videoDuration);
    formData.append('videoOreintation', videoHeightI < videoWidthI ? 1 : 2);
    formData.append('videoHeight', videoHeightI);
    formData.append('videoWidth', videoWidthI);
    selectedItems[index].category ? formData.append('category_id', selectedItems[index].category) : null;
    formData.append('playlist_ids', selectedItems[index]?.playlist?.map((item) => item?.value));
    formData.append('visibility', selectedItems[index].visibility);
    formData.append('group_ids', selectedItems[index]?.group_ids);
    formData.append('s3_url', `${s3Url}${getBucketNamePath(userId)}/${key}`);
    formData.append('s3_image_bucket_url', s3Url);
    formData.append('s3_status', 'Completed');
    formData.append('bucket_folder_path', `${getBucketNamePath(userId)}/${key}`);
    formData.append('video_size', formatFileSizeAccMb(file.size));
    closeToast(file?.draftId, 'Uploading completed', 'success');
    sendVideoDataToServer(formData, file?.draftId);
    if (subscriptionDetails?.current_plan === 'Free') {
      autoSignIn();
    }
    if (uploadQueue?.length <= 1) {
      setOpen();
        }
    return response;
  } catch (error) {
    console.error('Error completing multipart upload:', error);
    if (subscriptionDetails?.current_plan === 'Free') {
      autoSignIn();
    }
    throw error; // Rethrow the error to be handled by the caller
  }
}

const convertToBase64 = async (file) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

function base64ToFile(base64String, fileName) {
  const byteString = atob(base64String);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i += 1) {
    uint8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
  const file = new File([blob], fileName, { type: 'image/jpeg' });
  return file;
}

const ChangeButton = (newCategoryStates, updatedVideoFiles, singleArray) => {
  const mergeArrays = (array1, array2) => {
    const array2Map = new Map(array2.map((item) => [item?.draftId, item]));
    const result = array1.filter((item) => !array2Map.has(item?.draftId)).concat(array2);
    return result;
};
const filteredNewCategoryStates = singleArray === 'singleArray' ? mergeArrays(newCategoryStates, selectedItems) : newCategoryStates?.filter((categoryState) => updatedVideoFiles?.some((videoFile) => videoFile.draftId === categoryState.draftId));
  let c = 0;
  let t = 0;
  newCategoryStates.forEach((item, index) => {
    if (item?.category !== '') {
      c += 1;
    }
  });
  videoThumbnails64.forEach((item, index) => {
    if (item !== undefined) {
      t += 1;
    }
  });
  const allHaveCategory = filteredNewCategoryStates?.every((item) => item.category && item.category !== '');
  const someHaveCategory = filteredNewCategoryStates?.some((item) => item.category && item.category !== '');
  if (allHaveCategory) {
    setButtonText('Publish');
  } else if (someHaveCategory) {
    setButtonText('Publish & Save');
  } else {
    setButtonText('Save to Draft');
  }
};
const mediaThumGenerator = async (file, index) => {
  const video = document.createElement('video');
  video.src = URL.createObjectURL(file);
  setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'generating' }));

  return new Promise((resolve) => {
    video.addEventListener('loadeddata', async () => {
      const interval = video.duration / 6; // Generate thumbnails at 6 different points
      const thumbnails = []; // Store generated thumbnail files

      try {
        // eslint-disable-next-line
        for (let i = 1; i <= 6; i++) {
          const seekTime = i * interval; // Calculate the seek time for each thumbnail
          video.currentTime = seekTime; // Seek to the calculated time
// eslint-disable-next-line
          const thumbnailFile = await new Promise((innerResolve, innerReject) => {
            const onSeeked = () => {
              const canvas = document.createElement('canvas');
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

              canvas.toBlob((blob) => {
                if (blob) {
                  const file = new File([blob], `thumbnail_${index}_${i}.jpg`, { type: 'image/jpeg' });
                  innerResolve(file); // Resolve the promise with the generated thumbnail file
                } else {
                  innerReject(new Error('Failed to create thumbnail blob')); // Reject if blob creation fails
                }
              }, 'image/jpeg', 0.9); // Adjust quality as needed
            };

            video.addEventListener('seeked', onSeeked, { once: true });
          });

          // Check if thumbnail generation was successful
          if (thumbnailFile && thumbnailFile.size > 1000) {
            thumbnails.push(thumbnailFile); // Store the generated thumbnail file
          } else {
            throw new Error('Invalid thumbnail generated'); // Throw an error to break the loop
          }
        }

        // Update state with the generated thumbnails
        setVideoThumbnails((prevThumbnails) => {
          const updatedThumbnails = [...prevThumbnails];
          updatedThumbnails[index] = thumbnails; // Store all generated thumbnails for the video
          return updatedThumbnails;
        });

        // Convert the last thumbnail to base64 for state update
        const base64String = await convertToBase64(thumbnails[thumbnails.length - 1]);
        setVideoThumbnails64((prevThumbnails) => {
          const updatedThumbnails = [...prevThumbnails];
          updatedThumbnails[index] = base64String; // Update the last thumbnail as base64
          return updatedThumbnails;
        });
        setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'success' })); // Set success status
        resolve(); // Resolve the main promise
      } catch (error) {
        console.error('Thumbnail generation error:', error);
        setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'failed' })); // Set failed status

        // If frontend thumbnail generation failed, fall back to backend API
        const videoFilePiece = new FormData();
        videoFilePiece.append('video_file', file.slice(0, 5 * 1024 * 1024)); // Sending the first 5MB of the video file
        const apiUrl = 'https://conf.eq7.in/generate-thumbnail/';

        try {
          const response = await fetch(apiUrl, {
            method: 'POST',
            body: videoFilePiece,
          });
          const data = await response.json();
          if (data?.thumbnail) {
            const newThumbnailFile = base64ToFile(data.thumbnail, `thumbnail_${index}_backend.jpg`);
            setVideoThumbnails((prevThumbnails) => {
              const updatedThumbnails = [...prevThumbnails];
              updatedThumbnails[index] = newThumbnailFile; // Set the backend-generated thumbnail
              return updatedThumbnails;
            });
            setVideoThumbnails64((prevThumbnails) => {
              const updatedThumbnails = [...prevThumbnails];
              updatedThumbnails[index] = `data:image/png;base64, ${data.thumbnail}`; // Store base64
              return updatedThumbnails;
            });
            setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'success' })); // Set success status
          } else {
            // Handle failed backend thumbnail generation
            setVideoThumbnails((prevThumbnails) => {
              const updatedThumbnails = [...prevThumbnails];
              updatedThumbnails[index] = undefined; // Clear if failed
              return updatedThumbnails;
            });
            setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'failed' })); // Set failed status
          }
        } catch (error) {
          console.error('Error uploading file to backend:', error);
          setVideoThumbnails((prevThumbnails) => {
            const updatedThumbnails = [...prevThumbnails];
            updatedThumbnails[index] = undefined; // Clear if failed
            return updatedThumbnails;
          });
          setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'failed' })); // Set failed status
        }
      }
    });

    video.addEventListener('error', (error) => {
      console.error('Error processing video:', error);
      setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'failed' })); // Set failed status on error
    });

    // Timeout for thumbnail generation
    setTimeout(() => {
      setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'success' }));
      resolve(); // Resolve in case of timeout
    }, 45000);
  });
};

function formatFileSize(sizeInBytes) {
  const kilobyte = 1024;
  const megabyte = kilobyte * 1024;
  const gigabyte = megabyte * 1024;
  if (sizeInBytes >= gigabyte) {
    return `${(sizeInBytes / gigabyte).toFixed(2)} GB`;
  }
  if (sizeInBytes >= megabyte) {
    return `${(sizeInBytes / megabyte).toFixed(2)} MB`;
  }
  if (sizeInBytes >= kilobyte) {
    return `${(sizeInBytes / kilobyte).toFixed(2)} KB`;
  }
  return `${sizeInBytes} Bytes`;
}
let dragCounter = 0;
const dragOver = (e) => {
  e.preventDefault();
  if (dragCounter === 0) {
  setDroper(true);
  }
// eslint-disable-next-line no-plusplus
  dragCounter++;
};
const dragLeave = (e) => {
// eslint-disable-next-line no-plusplus
  dragCounter--;
  e.preventDefault();
  if (dragCounter === 0) {
  setDroper(false);
  }
};
useEffect(() => {
  videoFiles.map((obj, i) => {
    const { draftId } = obj;
    const fileNameWithoutExtension = obj.name.split('.').slice(0, -1).join('.');

    if (test[draftId]) {
      updateTitle(draftId, test[draftId]);
    } else {
      updateTitle(draftId, fileNameWithoutExtension);
    }

    if (!videoThumbnails[i] || videoThumbnails[i].length < 2) {
      mediaThumGenerator(obj, i);
    }
    return false;
  });
  setT(true);
}, [videoFiles]);

const handleCheckboxChange = (name, size) => {
  setSelectedItems((prevItems) => {
    const isSelected = prevItems.some((item) => item.name === name);
    if (isSelected) {
      return prevItems.filter((item) => item.name !== name);
    }
    return [
      ...prevItems,
      {
        token: getToken(),
        draftId: '',
        group_ids: [],
        thumbnails: '',
        name,
        description: '',
        category: '',
        playlist: [],
        visibility: '',
        size,
      },
    ];
  });
};

const handlePlaylistChange = (event, index) => {
  setSelectedItems((prevItems) => {
    const newItems = [...prevItems];
    newItems[index] = {
      ...newItems[index],
      playlist: event.target.value,
    };
    return newItems;
  });
};
const [arrayUpdater, setarrayUpdater] = useState(false);
const [isSyncEnabled, setIsSyncEnabled] = useState(false); // Switch state to control sync
const [lastSelectedCategory, setLastSelectedCategory] = useState({ value: '', name: '' });

const handleCategoryChange = (event, index) => {
if (event.target.value !== undefined) {
  setAddingNewCategory((prevState) => {
    const updatedState = {};
    Object.keys(prevState).forEach((key) => {
      if (prevState[key] === true) {
        updatedState[key] = false;
      }
    });
    return updatedState;
  });
  const newCategoryStates = [...selectedItems]; // Copy the current state
  const selectedCategoryValue = event.target.value;
  // Find the selected category name based on the value
  const selectedCategoryName = categrory.find(
    (categoryOption) => categoryOption.value === selectedCategoryValue
  )?.name || 'Default';

  if (isSyncEnabled) {
    // If sync is enabled, apply the selected category to all items
    const updatedCategoryStates = newCategoryStates.map((item) => ({
      ...item,
      category: selectedCategoryValue,
      categoryName: selectedCategoryName,
    }));

    // Update the state and ChangeButton with the synced categories
    ChangeButton(updatedCategoryStates, videoFiles);
    setSelectedItems(updatedCategoryStates);
  } else {
    // If sync is off, update only the selected item
    newCategoryStates[index] = {
      ...newCategoryStates[index],
      category: selectedCategoryValue,
      categoryName: selectedCategoryName,
    };

    // Track the last selected category
    setLastSelectedCategory({ value: selectedCategoryValue, name: selectedCategoryName });

    // Update the state and ChangeButton with the updated individual category
    ChangeButton(newCategoryStates, videoFiles);
    setSelectedItems(newCategoryStates);
  }
  setarrayUpdater(!arrayUpdater); // Trigger the re-render if needed
}
};

const handleSwitchToggle = (event) => {
  const isSwitchOn = event.target.checked;
  setIsSyncEnabled(isSwitchOn);
  setAddingNewCategory((prevState) => {
    const updatedState = {};
    Object.keys(prevState).forEach((key) => {
      if (prevState[key] === true) {
        updatedState[key] = false;
      }
    });
    return updatedState;
  });
  if (isSwitchOn && lastSelectedCategory) {
    // When the switch is turned on, sync all items to the last selected category
    const updatedCategoryStates = selectedItems.map((item) => ({
      ...item,
      category: lastSelectedCategory.value,
      categoryName: lastSelectedCategory.name,
    }));

    // Update all items with the last selected category
    ChangeButton(updatedCategoryStates, videoFiles);
    setSelectedItems(updatedCategoryStates);
  }
};

const handleInputChange = (e, index) => {
  e.preventDefault(); // Prevent default behavior
  setTitle(e.target.value);
};

const handleSubmit = async (e, index) => {
  setAddEditCategory(true);
  setIsSyncEnabled(false);
  e.preventDefault(); // Prevents page reload
  const payload = {
    category_id: '',
    icon: '1',
    title, // The text entered in the input field
    token: getToken(), // Assuming you have a getToken function
  };
  try {
    const response = await axios.post(`${baseUrl}/addEditCategory`, payload);
    fetchCategories();
    const { category_id, title: newCategoryName } = response.data; // Extract the new category details
    // After successful submission, update the selected category for the specific file
    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index] = {
        ...updatedItems[index],
        category: category_id, // Use the new category ID from the response
        categoryName: title, // Use the new category name from the response
      };
      return updatedItems;
    });
    setLastSelectedCategory({ value: category_id, name: title });
    setAddingNewCategory((prev) => ({
      ...prev,
      [index]: false, // Update only the specific index
    }));
    setTitle('');
    setAddEditCategory(false);
  } catch (error) {
    console.error('Error:', error); // Handle error
    setAddEditCategory(false);
  }
};
const handleAddNewClick = (index) => {
  setIsSyncEnabled(false);

  // Close any open "Add New" inputs and open the clicked one
  setAddingNewCategory((prev) => {
    const newCategoryState = {};

    // Set all items to false except the one that was clicked
    Object.keys(prev).forEach((key) => {
      newCategoryState[key] = false;
    });

    newCategoryState[index] = true; // Open the clicked one
    return newCategoryState;
  });
};

const handleDescriptionChange = (event, index) => {
  const { value } = event.target;
  setSelectedItems((prevItems) => prevItems.map((item, i) => (i === index ? { ...item, description: value } : item)));
};
const visibilityText = langText?.visibility;
const videoVisibilityOptions = [
  { name: 'All Viewers' || visibilityText?.publicDescription, value: '2' },
  { name: visibilityText?.privateDescription || 'Only I can view (Private)', value: '1' },
  { name: 'Choose a group', value: '3' },
];
const [openGroups, setOpenGroups] = useState(Array(selectedItems.length).fill(false));

const handleVisibilityChange = (event, index) => {
  const newVisibilityStates = [...selectedItems];
  newVisibilityStates[index] = {
    ...newVisibilityStates[index],
    visibility: event.target.value
  };
  const newOpenGroups = Array.isArray(openGroups) ? [...openGroups] : [];
  newOpenGroups[index] = event.target.value === '3';
  setSelectedItems(newVisibilityStates);
  setOpenGroups(newOpenGroups);
};
const handleMenuItems = (index, i) => {
  const newOpenGroups = Array.isArray(openGroups) ? [...openGroups] : [];
  newOpenGroups[i] = true;
  if (index === 2) {
  setOpenGroups(newOpenGroups);
} else {
  setOpenGroups(false);
}
  };
const handleMenuItemClick = (index) => {
  const newOpenGroups = [...openGroups];
  newOpenGroups[index] = false;
  setOpenGroups(newOpenGroups);
};
const updateUploadPercentages = (draft_id, data) => {
  dispatch(saveUploadInfo({ [draft_id]: data }));
};
const notify = (filename, draft_id, uploadPercentages, updateUploadPercentages) => {
  setTimeout(() => {
    const newPercentages = { ...uploadPercentages, [draft_id]: 'Starting Upload' };
    tempPercentages = newPercentages;
    updateUploadPercentages(draft_id, 'Starting Upload');
    const trimmedFilename = filename.length > 26 ? `${filename.substring(0, 26)}...` : filename;
    toast(trimmedFilename, {
      autoClose: false,
      toastId: draft_id,
      position: toast.POSITION.BOTTOM_RIGHT,
      closeButton: <CustomCloseButton draft_id={draft_id} updateUploadPercentages={updateUploadPercentages} />,
      toastClassName: 'custom-toast'
    });
  }, 0);
};
async function uploadPartSequentially(file, bucket, key, uploadId, partNumber, start, partSize, parts, draft_id, startTime) {
  const end = Math.min(start + partSize, file.size);
  const data = {};
  const dataCallback = (snapshot) => {
    if (snapshot.exists()) {
      const dataObj = snapshot.val();
      data[draft_id] = dataObj[draft_id];
    }
  };
  onValue(databaseRef, dataCallback);
  const unsubscribe = () => {
    off(databaseRef, 'value', dataCallback);
  };
  if (data[draft_id]?.status !== 'DELETED') {
    await uploadPart(getBucketName(userId), key, partNumber, file.slice(start, end), uploadId, setVideoUploadedParts, file.name, draft_id, uploadPercentages, updateUploadPercentages, partSize, startTime, file.size)
    .then((item) => {
      parts.push({ PartNumber: partNumber, ETag: item.ETag });
    });
  } else {
    unsubscribe();
  }
  unsubscribe();
  if (end < file.size) {
    await uploadPartSequentially(file, bucket, key, uploadId, partNumber + 1, end, partSize, parts, draft_id, startTime);
  }
}

async function initMultipartUpload(bucket, key) {
  const params = {
    Bucket: bucket,
    Key: key,
  };

  return s3.createMultipartUpload(params).promise();
}

const updateDummy = (dummy, status = 0) => {
  if (status === 1) {
    dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
  } else {
    dispatch(removeDummy(dummy));
  }
};
const handleEncouter = (draft_id) => {
  if (uploadQueue?.length <= 1) {
    setOpen();
      }
  toast.update(draft_id, {
    closeButton: <CustomCloseloader />,
  });

  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  changeFieldFromFirebase(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'DELETED');
  updateDummy(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 0);
  setIamUploading(false);
  setActiveUploads((prevUploads) => prevUploads?.filter((id) => id !== draft_id?.draft_id));
  setDraftOfUpload((prevUploads) => prevUploads?.filter((id) => id !== draft_id?.draft_id));
  setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => id !== draft_id?.draft_id));
  updateUploadPercentages(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'Cancelled');
  closeToast(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'Upload has been canceled by user', 'error');
};

const backToOld = ({ draft_id, updateUploadPercentages }) => {
  toast.update(draft_id, {
    closeButton: <CustomCloseButton draft_id={draft_id} updateUploadPercentages={updateUploadPercentages} />,
  });
};
const CustomCloseDiv = (draft_id, updateUploadPercentages) => (
  <div className={styles.customDiv}>
    Are you sure you want to cancel ?
    <div className={styles.fleo}>
      <button className={styles.cancelPlz} onClick={() => backToOld(draft_id, updateUploadPercentages)}>
      Exit
      </button>
      <button className={styles.noCancel} onClick={() => handleEncouter(draft_id)}>
        Continue to cancel
      </button>
    </div>
  </div>
);
const handleClick = (draft_id, updateUploadPercentages) => {
  toast.update(draft_id, {
    closeButton: <CustomCloseDiv draft_id={draft_id} updateUploadPercentages={updateUploadPercentages} />,
  });
};
const CustomCloseloader = () => (
  <button className={styles.closeMeBro}>
  <Spinner />
  </button>
);

const CustomCloseButton = ({ draft_id }) => (
  <button className={styles.closeMeBro} onClick={() => handleClick(draft_id)}>
    <CloseIcon />
  </button>
);

async function uploadLargeFile(bucket, key, file, draft_id, index, fileName) {
  setUploadContainer((prevUploadContainer) => [...prevUploadContainer, draft_id]);
  setUploadContainer2((prevUploadContainer) => [...prevUploadContainer, draft_id]);
  try {
    notify(file.name, draft_id, uploadPercentages, updateUploadPercentages);
    const { UploadId } = await initMultipartUpload(bucket, fileName);
    const minimumPartSize = 5 * 1024 * 1024; // 5MB -- aws s3 bucket requires atlease 5MB/packet currently
    let partSize = file.size / 100; // splitting to 100 packets to perform 1 packet as for 1 percent
    if (partSize < minimumPartSize) {
      partSize = minimumPartSize;
    }
    const fileSize = file.size;
    const partCount = Math.ceil(fileSize / partSize);
    const startTime = new Date().getTime();
    const parts = [];
    iteratorNum[draft_id] = 0;
    totalNum[draft_id] = partCount;
    await uploadPartSequentially(file, bucket, fileName, UploadId, 1, 0, partSize, parts, draft_id, startTime);
    const data = {};
    const dataCallback = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        data[draft_id] = dataObj[draft_id];
      }
    };
    onValue(databaseRef, dataCallback);
    const unsubscribe = () => {
      off(databaseRef, 'value', dataCallback);
    };
    if (data[draft_id]?.status !== 'DELETED') {
      const uploadedData = await completeMultipartUpload(bucket, fileName, parts, UploadId, file, index);
      const newPercentages = { ...uploadPercentages, [draft_id]: 'Please wait' };
      tempPercentages = newPercentages;
      updateUploadPercentages(draft_id, 'Please wait');
      iteratorNum[file.name] = 0;
      totalNum[draft_id] = 0;
      setIamUploading(true);
    } else {
      updateUploadPercentages(draft_id, 'Cancelled');
      closeToast(draft_id, 'Upload has been canceled by user', 'error');
      unsubscribe();
    }
    unsubscribe();
  } catch (error) {
    if (localStorage.getItem('opened_draft_id') === draft_id) {
      // hideModal();
    }
    updateUploadPercentages(draft_id, 'Cancelled');
    closeToast(draft_id, 'Upload has been canceled by user', 'error');
    const newPercentages = { ...uploadPercentages, [draft_id]: 'Cancelled' };
    tempPercentages = newPercentages;
    updateUploadPercentages(draft_id, 'Cancelled');
    updateUploadDetails(draft_id, { elapsed_size: 0, elapsed_time: 0, remaining_size: 0 });
    const allPropertiesAreNumericOrString = Object.values(uploadPercentages).some((value) => typeof value === 'number' || value === 'Starting Upload' || value === 'Initializing');
    if (allPropertiesAreNumericOrString) {
      setIamUploading(false);
    } else setIamUploading(true);
  }
}

function changeSize(size) {
  const newSize = size / 1024 / 1024;
  return newSize.toFixed(2);
}

async function processUploadQueue() {
  if (activeUploads.length < 5 && uploadQueue.length > 0) {
    // Get the next file from the queue
    const nextUpload = uploadQueue[0];

    // Start the upload and remove it from the queue
    setActiveUploads((prevUploads) => [...prevUploads, nextUpload.draftId]);
    setUploadQueue((prevQueue) => prevQueue.slice(1));

    await uploadLargeFile(getBucketName(userId), nextUpload.file.name, nextUpload.file, nextUpload.draftId, nextUpload.index, nextUpload.fileName);
    // Remove from active uploads once completed
    setActiveUploads((prevUploads) => prevUploads.filter((id) => id !== nextUpload.draftId));
  }
}

useEffect(() => {
  if (uploadQueue.length > 0 && activeUploads.length < 5) {
    processUploadQueue();
  }
}, [uploadQueue, activeUploads]);

async function handleInitMultipartUpload() {
  // setOpen(false);
  setSelectedFiles([]);
  setDraftOfUpload([]);
  videoFiles.forEach((file, index) => {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const number = Math.floor(Math.random() * 10000) + 1;
    const fileName = `${Date.now()}-${userId}-video-${number}.${fileExtension}`;
    // Add file to the upload queue
    setUploadQueue((prevQueue) => [
      ...prevQueue,
      { file, index, fileName, draftId: file.draftId }
    ]);
    setDraftOfUpload((prevDraftIds) => [...prevDraftIds, file.draftId]);
    const currentDate = new Date();
    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const formattedDate = `${String(month).padStart(2, '0')}/${String(date).padStart(2, '0')}/${year}`;
    let type_of;
    let contentStatus;
    if (selectedItems[index].category && videoThumbnails[index] && selectedItems[index].visibility && videoThumbnails64[index] !== undefined) {
      type_of = 0;
      contentStatus = 'Video';
    } else {
      type_of = 2;
      contentStatus = 'Draft';
    }
    const dummy = {
      draft_id: file.draftId,
      title: test[file.draftId] || fileName,
      thumbnail: videoThumbnails64[index],
      category: selectedItems[index].categoryName,
      video_description: selectedItems[index].description,
      created: formattedDate,
      video_size: changeSize(file?.size),
      type: type_of,
      group_id: selectedItems[index]?.group_ids,
      content_status: contentStatus,
      uploadIsTrying: 1,
    };
    updateDummy(dummy, 1);
  });
  processUploadQueue();
  setIsVisible(false);
  setNavigateOnceClicked(true);
  // setTimeout(() => {
  // }, 300);
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const handleDelete = (id, index) => {
  const updatedVideoThumbnails = [...videoThumbnails];
  const updatedVideoThumbnails64 = [...videoThumbnails64];
  updatedVideoThumbnails.splice(index, 1);
  updatedVideoThumbnails64.splice(index, 1);
  setVideoThumbnails(updatedVideoThumbnails);
  setVideoThumbnails64(updatedVideoThumbnails64);
  updateTitle(index, null, 0);
  const updatedSelectedItems = selectedItems.filter((item) => item?.draftId !== id);
  setSelectedItems(updatedSelectedItems);
  const updatedVideoFiles = videoFiles.filter((file) => file.draftId !== id);
  setVideoFiles(updatedVideoFiles);
  setVideoGroup((prevVideoGroup) => {
    const updatedVideoGroup = [...prevVideoGroup];
    updatedVideoGroup.splice(index, 1);
    return updatedVideoGroup;
  });
  if (updatedVideoFiles.length === 0) {
    setOpen();
  }
  ChangeButton(selectedItems, updatedVideoFiles);
  setarrayUpdater(!arrayUpdater);
};
const [inputTrigger, setInputTrigger] = useState(false);

const MAX_SIZE_GB = 30;
const MAX_SIZE_BYTES = MAX_SIZE_GB * 1024 * 1024 * 1024;
const allowedExtensions = ['mp4', 'mov', 'mpg', 'm4v', 'm2ts'];
const handleFileChange = (event) => {
  dragCounter = 0;
  setDroper(false);
  event.preventDefault(); // Prevent default behavior for both drag-and-drop and file input

  // Determine the source of files: Drag and drop (dataTransfer) or file input (target.files)
  const newFiles = Array.from(event.dataTransfer?.files || event.target.files);

  newFiles.forEach((file) => {
    // eslint-disable-next-line
    file.draftId = uuid(); // Add unique ID
    // eslint-disable-next-line
    file.visibility = '2'; // Add visibility status
  });

  // Validate file formats
  const invalidFiles = newFiles.filter((file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    return !allowedExtensions.includes(extension);
  });

  if (invalidFiles.length > 0) {
    setAppSnackbar({ isVisible: true, type: 'error', message: 'Invalid file format. Allowed formats are: .mp4, .mov, .mpg, .m4v, .m2ts' });
    return;
  }

  const combinedFiles = [...videoFiles, ...newFiles];
  const totalSize = combinedFiles.reduce((acc, file) => acc + file.size, 0);

  // Validate file count and total size
  if (combinedFiles.length > MAX_VIDEOS) {
    setAppSnackbar({ isVisible: true, type: 'error', message: `You can only select ${MAX_VIDEOS} videos` });
    return;
  }

  if (totalSize > MAX_SIZE_BYTES) {
    setAppSnackbar({ isVisible: true, type: 'error', message: `Total file size should not exceed ${MAX_SIZE_GB}GB.` });
    return;
  }
  // Update state with valid files
  setSelectedItems((prevItems) => [
    ...prevItems,
    ...newFiles.map((file) => ({
      token: getToken(),
      group_ids: [],
      draftId: file.draftId,
      thumbnails: '',
      name: file.name,
      description: '',
      category: '',
      playlist: [],
      visibility: file.visibility,
      size: file.size,
    })),
  ]);

  setVideoFiles((prevFiles) => [...prevFiles, ...newFiles]);
  ChangeButton(combinedFiles, null, 'singleArray');
  setIsSyncEnabled(false);
};

const groupRefs = useRef([]);
const setGroupRef = (index) => (element) => {
  groupRefs.current[index] = element;
};

const label = { inputProps: { 'aria-label': 'Select all' } };
useEffect(() => {
  function handleClickOutside(event) {
    // setAddingNewCategory((prevState) => {
    //   const updatedState = { ...prevState }; // Copy previous state
    //   Object.keys(prevState).forEach((key) => {
    //     if (prevState[key] === true) {
    //       updatedState[key] = false; // Only set true values to false
    //     }
    //   });
    //   return updatedState;
    // });
    groupRefs.current.forEach((ref, index) => {
      if (ref && !ref.contains(event.target)) {
        const newOpenGroups = [...openGroups];
        newOpenGroups[index] = false;
        setOpenGroups(newOpenGroups);
      }
    });
  }
  document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
}, [openGroups, setOpenGroups]);

  return (
    <div
    onDrop={handleFileChange}
    onDragOver={(e) => dragOver(e)}
    onDragLeave={(e) => dragLeave(e)}
    style={{
      display: isVisible ? 'block' : 'none',
    }}
      className={styles.positioningModel}
      onKeyPress={undefined}
      role="button"
      tabIndex={0}
      // onClick={(event) => handleClose(event)}
    >
      {droper
&& (
<div
  role="button" // Adds the appropriate role
  tabIndex={0} // Makes it focusable by keyboard
  onClick={() => { setDroper(false); dragCounter = 0; }}
  onKeyPress={(event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      dragCounter = 0; // Also handles Enter/Space key press for accessibility
    }
  }}
  className={styles.bigCover}
>
  <img className={styles.imgCenter} src={CloudUpl} alt="" />
</div>

)}
      <div
        onKeyPress={undefined}
        role="button"
        tabIndex={0}
        onClick={(event) => {
          event.stopPropagation();
          // if (Object.values(addingNewCategory).some((value) => value === true)) {
          //   setAddingNewCategory((prevState) => {
          //     const updatedState = {};
          //     Object.keys(prevState).forEach((key) => {
          //       if (prevState[key] === true) {
          //         updatedState[key] = false;
          //       }
          //     });
          //     return updatedState;
          //   });
          // }
        }}
        className={styles.bringCenter}
      >
        <div className={styles.heading}>
          Must Choose Video Category For Each Video In Order To Publish That Video
        </div>
        <div className={styles.headingh3}>
          To Add Subcategory, Change Thumbnail, And Add Video Description, Edit In Content Dashboard&gt;Content
<div>
<span>Apply Same Category to all videos</span>
<Switch
            checked={isSyncEnabled} // Bind switch state
            onChange={handleSwitchToggle}
/>
</div>
        </div>
        <hr className={styles.linex} />
        <div className={styles.overScrollMe}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
          <TableRow>
            {/* <TableCell>
              <Checkbox
              status={selectedItems?.length === videoFiles?.length}
              />
            </TableCell> */}
            <TableCell>
              <div className={styles.TbleCel}>
              Content Preview
              </div>
            </TableCell>
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
                Video Title
              </div>
            </TableCell>
            {/* <TableCell>
              Description
            </TableCell> */}
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
            Category
              </div>
            </TableCell>
            {/* <TableCell>
              Playlist
            </TableCell> */}
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
              Visiblity
              </div>
            </TableCell>
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
              Size
              </div>
            </TableCell>
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
              Actions
              </div>
            </TableCell>
          </TableRow>
          </TableHead>
         { t === true ? (
            <TableBody>
            {videoFiles?.map((obj, i) => (
              <TableRow key="" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                {/* <TableCell>
                  <Checkbox
                    status={selectedItems?.some((item) => item?.name === obj?.name)}
                    onClick={() => handleCheckboxChange(obj?.name, obj?.size)}
                  />
                </TableCell> */}
                <TableCell>
                <video ref={videoRef} style={{ display: 'none' }} controls />
                <div className={styles.previewContainer}>
                {videoThumbnails[i] ? (
                  <img
                    className={styles.previewImage}
                    src={(() => {
                      try {
                        return URL.createObjectURL(videoThumbnails[i][0]);
                      } catch (error) {
                        console.error('Failed to create object URL:', error);
                        return videoThumbnails64?.[i] ?? noImageAvailable;
                      }
                    })()}
                    alt={obj?.title}
                  />
                )
                : (
                <img style={{ objectFit: 'contain' }} className={styles.previewImage} src={noImageAvailable} alt={obj?.title} />)}
                </div>
                </TableCell>
                <TableCell component="th" scope="row">
                  <div className={styles.nameBal}>
                      <input type="text" placeholder="Title" value={test[obj.draftId]} onChange={(e) => updateTitle(obj.draftId, e.target.value)} className={styles.titles} />
                  </div>
                </TableCell>
                {/* <TableCell component="th" scope="row">
                <textarea className={styles.description} placeholder="Description" value={selectedItems?.length > 0 ? selectedItems[i]?.description : ''} onChange={(e) => handleDescriptionChange(e, i)} />
                </TableCell> */}
<TableCell sx={{ width: '233px', textAlign: 'center' }}>
                {categrory !== undefined
                  ? (addingNewCategory[i] ? (
                    // Show input form when adding a new category
                    <form className={styles.addnewForm} onSubmit={(e) => handleSubmit(e, i)}>
<button
  onClick={() => {
    setTitle('');
 setAddingNewCategory((prevState) => {
    const updatedState = { ...prevState }; // Copy previous state
    Object.keys(prevState).forEach((key) => {
      if (prevState[key] === true) {
        updatedState[key] = false; // Only set true values to false
      }
    });
    return updatedState;
  });
}}
  style={{
    background: 'transparent',
  }}
>
  <CloseIcon />
</button>

                      <input
                        type="text"
                        value={title}
                        className={styles.titles}
                        onChange={handleInputChange}
                        placeholder="Enter Category"
                      />
                      <button
style={{
    opacity: title === '' ? '0' : '1',
    cursor: title === '' ? 'not-allowed' : 'pointer' // Optional: change cursor based on button state
  }}
disabled={title === ''}
type="submit"
                      >
                      {addEditCategory ? (
  <Spinner spinex={spinerSmall} />
) : (
  'Add'
)}
                      </button>
                    </form>
                  ) : (
<div className={styles.tabletC}>
<button style={{ opacity: '0' }}>
<CloseIcon />
</button>
<FormControl key={i} sx={{ m: 1, width: 120 }}>
                    <InputLabel
                      htmlFor={`category-select-${i}`}
                      color="primary"
                    >
                      {categrory?.length < 0 ? 'No Category' : 'Category'}
                    </InputLabel>
                    <Select
                    onClick={(e) => handleCancel(e, i)}
                    value={selectedItems[i] !== undefined && selectedItems[i]?.category}
                      onChange={(e) => handleCategoryChange(e, i)}
                      input={<OutlinedInput label="category" />}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                  <MenuItem
                  disableRipple
                  disableTouchRipple
                  onClick={() => handleAddNewClick(i)}
                  sx={{ color: '#5AA5EF', fontWeight: 500 }}
                  >
                  <Typography variant="inherit" noWrap>Add new</Typography>
                  </MenuItem>
                      {categrory?.length > 0
                        && categrory.map((categoryOption, index) => (
                          <MenuItem key={index} value={categoryOption.value || index + 1}>
                            {categoryOption.name || 'Default Name'}
                          </MenuItem>
                        ))}
                    </Select>
</FormControl>
<button style={{ opacity: '0' }}>
<CloseIcon />
</button>
</div>
                  )
                  )
                : <Spinner spinex={spinerSmall} />}
</TableCell>
                {/* <TableCell>
                    {options?.length > 0 ? (
                      <FormControl sx={{ m: 1, width: 200 }}>
                         <InputLabel htmlFor={`playlist-select-${i}`} color="primary">Playlist</InputLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          value={selectedItems[i]?.playlist}
                          onChange={(e) => handlePlaylistChange(e, i)}
                          input={<OutlinedInput label="Playlist" />}
                          renderValue={(selected) => selected.map((item) => item.name).join(', ')}
                          MenuProps={MenuProps}
                        >
                          {selectedItems[i]?.playlist?.length <= 0 && ( // Render the placeholder only when no playlist is selected
                            <MenuItem value="" disabled>
                              Select Playlist
                            </MenuItem>
                          )}
                          {options && options?.map((option, index) => (
                            <MenuItem key={index} value={option || index + 1}>
                              <StyledCheckbox
                                checked={selectedItems[i]?.playlist?.includes(option) || false}
                              />
                              <ListItemText primary={option?.name || 'Default Name'} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : <Spinner spinex={spinerSmall} />}

                </TableCell> */}
                <TableCell>
                  <div className={styles.visibilityContainer}>
                       <FormControl sx={{ m: 1, width: 252 }}>
                          <Select
                            value={selectedItems[i]?.visibility || '2'}
                            onChange={(e) => handleVisibilityChange(e, i)}
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                          {videoVisibilityOptions?.map((option, index) => (
                            <MenuItem onClick={() => handleMenuItems(index, i)} key={index} value={option?.value || index + 1}>
                              {option?.name || 'Default Name'}
                            </MenuItem>
                          ))}
                          </Select>
                       </FormControl>
                        {/* {selectedItems[i].visibility === videoVisibilityOptions[2].value && ( */}
                        {openGroups[i] && (
                          <div ref={setGroupRef(i)}>
                            <GroupSelector
                              isBulk
                              onSelect={(val) => { selectGroup(val, i); }}
                              selectedOption={selectedItems[i]?.group_ids || []}
                              setOpenGroups={setOpenGroups}
                              handleMenuItemClick={handleMenuItemClick}
                              index={i}
                            />
                          </div>
                        )}
                  </div>
                </TableCell>
                <TableCell>
                  <div className={styles.sizeBal}>
                {formatFileSize(obj.size)}
                  </div>
                </TableCell>
                <TableCell>
                {/* <div style={{ backgroundColor: 'none', cursor: 'pointer', width: 'auto', height: 'auto' }} > */}
                <button disabled={isLoading} onClick={() => !isLoading && handleDelete(obj.draftId, i)} style={{ backgroundColor: 'transparent', cursor: isLoading ? 'default' : 'pointer', opacity: isLoading ? '0.5' : '1' }}>
                  <img src={DeleteIcon} alt="Remove" style={{ height: '25px', width: '25px' }} />
                </button>
                </TableCell>
              </TableRow>
            ))}
            </TableBody>
            )
            : (null) }
          </Table>
        </TableContainer>
        </div>
      <div className={styles.flexico}>
        <span style={{ fontSize: '14px' }} className={styles.heading}>
        {selectedItems?.length}
        {' '}
        Videos added
        </span>
        { videoFiles.length < MAX_VIDEOS
        && (
          <div className={styles.flexButton}>
            <label htmlFor="video-upload" className={styles.labelButton}>
              Add Files
            </label>
            <input onChange={handleFileChange} type="file" accept="video/*" multiple id="video-upload" className={styles.hiddenInput} />
          </div>
        )}
        <div className={styles.flexButtun}>
          <button
          onClick={() => { setOpen(false); setSelectedFiles([]); }}
          className={styles.cancel}
          >
            Cancel
          </button>
          <button
            disabled={isLoading}
            className={styles.save}
            style={{ cursor: isLoading ? 'default' : 'pointer', opacity: isLoading ? '0.5' : '1' }}
            onClick={!isLoading && handleInitMultipartUpload}
          >
            {buttonText}
          </button>
        </div>
      </div>
      </div>
    </div>
  );
}
